import { io } from "socket.io-client";
import store from "@/store";

const SOCKET_URL = process.env.VUE_APP_SOCKET_URL || (process.env.NODE_ENV === 'production' ? window.location.origin : "http://localhost:5000");

let socket;

export const initSocket = () => {
    const user = store.state.auth.user;

    socket = io(SOCKET_URL);

    socket.on("connect", () => {
        console.log("Connected to Socket.IO server");

        if (user && user.id) {
            socket.emit("join", user.id);

            if (user.role === 'admin') {
                socket.emit("join_admin");
            }
        }
    });

    socket.on("new_notification", (notification) => {
        console.log("Real-time notification received:", notification);
        // Add to store
        store.dispatch('notifications/addNotification', notification);

        // Trigger localized browser toast/notification if needed
        if (window.Notification && Notification.permission === "granted") {
            new Notification(notification.title, {
                body: notification.message,
                icon: '/favicon.ico'
            });
        }
    });

    socket.on("new_message", (message) => {
        console.log("Real-time message received:", message);
        // Dispatch a global event so views can listen
        window.dispatchEvent(new CustomEvent('new-inbox-message', { detail: message }));
    });

    socket.on("disconnect", () => {
        console.log("Disconnected from Socket.IO server");
    });

    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
    }
};
